import React from "react";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
import Card from "../../atoms/Card";
import CardImage from "../../atoms/CardImage/CardImage.styled";
import CardContent from "../../atoms/CardContent";
import { H4 } from "../../atoms/H/H.styled";
import Text from "../../atoms/Text";
import { isMobile } from "../../../AppTheme.styled";
import PrincipalID from "../PrincipalID";

export interface IProductCard {
  width?: number;
  productUrl: string;
  productImage: string;
  productName: string;
  productCase: string;
  owner?: string;
  price?: string;
}

const ProductCard = ({
  width,
  productUrl,
  productName,
  productImage,
  productCase,
  owner,
  price,
}: IProductCard) => (
  <Link to={productUrl}>
    <Card width={width}>
      <CardImage src={productImage} />
      <CardContent>
        <H4 spacing={isMobile ? [0, 1 / 4] : [0, 1]}>{productName}</H4>
        {productCase && (
          <Text size="small" color="neutral3">
            {productCase}
          </Text>
        )}
        {owner && (
          <Text size="small" color="neutral3">
            Owned by <PrincipalID principal={owner} />
          </Text>
        )}
        {price && (
          <>
            <br />
            <Grid container justify="space-between">
              <Grid item>
                <Text size="small" color="neutral3">
                  Price:
                </Text>
              </Grid>
              <Grid item>
                <Text size="small" color="primary">
                  <b>{price}</b>
                </Text>
              </Grid>
            </Grid>
          </>
        )}
      </CardContent>
    </Card>
  </Link>
);

export default ProductCard;
